<template>
  <DialogRoot :open="isOpen" @update:open="onOpenChange">
    <DialogPortal to="#modals">
      <DialogOverlay class="overlay_modal g-0">
        <DialogContent
          class="modal_component"
          :aria-describedby="undefined"
        >
          <VisuallyHidden as-child>
            <DialogTitle>{{
              $t('components.notifications.notifications')
            }}</DialogTitle>
          </VisuallyHidden>
          <slot></slot>
        </DialogContent>
      </DialogOverlay>
    </DialogPortal>
  </DialogRoot>
</template>

<script>
import {
  DialogRoot,
  DialogPortal,
  DialogOverlay,
  DialogContent,
  DialogTitle,
  VisuallyHidden,
} from 'reka-ui'

export default {
  name: 'Modal',
  components: {
    DialogRoot,
    DialogPortal,
    DialogOverlay,
    DialogContent,
    DialogTitle,
    VisuallyHidden,
  },
  props: {
    isOpen: Boolean,
    closeHandler: Function,
  },
  methods: {
    handleCloseModal() {
      if (this.closeHandler && this.isOpen) this.closeHandler()
    },
    onOpenChange(open) {
      if (!open) this.handleCloseModal()
    },
  },
}
</script>

<style scoped>
.overlay_modal {
  display: flex;
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
  padding: 1rem;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
